(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["interactive-banner-wpp-custom"] && !Shopify.designMode) return;
  try {
    
  (function() {
    const sections = document.querySelectorAll('.interactive-banner');
    if (!sections.length) return;

    const isMobile = () => window.innerWidth <= 768;

    sections.forEach((root) => {
      const buttonsWrapper = root.querySelector('.interactive-banner__buttons');
      const buttons = root.querySelectorAll('.interactive-banner__button');
      const bgContainer = root.querySelector('.interactive-banner__background');
      const bgLayer = root.querySelector('.interactive-banner__bg-layer');

      if (!buttonsWrapper || !buttons.length || !bgContainer || !bgLayer) return;

      const getImageForElement = (el) => {
        if (!el) return '';
        if (isMobile()) {
          return el.dataset.mobileUrl || el.dataset.defaultMobile || el.dataset.desktopUrl || el.dataset.defaultDesktop || '';
        }
        return el.dataset.desktopUrl || el.dataset.defaultDesktop || '';
      };

      const changeImage = (url) => {
        if (!url) return;
        const current = bgContainer.dataset.currentImage;
        if (current === url) return;

        bgContainer.dataset.currentImage = url;
        bgLayer.style.opacity = '0';
        window.setTimeout(() => {
          bgLayer.style.backgroundImage = 'url(' + url + ')';
          bgLayer.style.opacity = '1';
        }, 60);
      };

      // Carrega a imagem inicial correta (mobile ou desktop) ao abrir
      const initialImg = getImageForElement(bgContainer);
      if (initialImg) {
        bgLayer.style.backgroundImage = 'url(' + initialImg + ')';
        bgContainer.dataset.currentImage = initialImg;
      }

      const handleButtonInteraction = (button) => {
        const url = getImageForElement(button);
        if (!url) return;

        const active = root.querySelector('.interactive-banner__button--active');
        if (active && active !== button) {
          active.classList.remove('interactive-banner__button--active');
          active.setAttribute('aria-selected', 'false');
        }

        button.classList.add('interactive-banner__button--active');
        button.setAttribute('aria-selected', 'true');

        changeImage(url);
      };

      buttons.forEach((button) => {
        button.addEventListener('mouseenter', () => handleButtonInteraction(button));
        button.addEventListener('focus', () => handleButtonInteraction(button));
        button.addEventListener('click', (e) => {
          if (button.getAttribute('href') === '#') {
            e.preventDefault();
          }
          handleButtonInteraction(button);
        });
      });

      buttonsWrapper.addEventListener('mouseleave', () => {
        const defaultUrl = getImageForElement(bgContainer);
        if (!defaultUrl) return;

        const active = root.querySelector('.interactive-banner__button--active');
        if (active) {
          active.classList.remove('interactive-banner__button--active');
          active.setAttribute('aria-selected', 'false');
        }

        changeImage(defaultUrl);
      });
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  document.addEventListener(
    'click',
    function (e) {
      const loadMoreBtn = e.target.closest('.load-more-pagination__button');
      if (!loadMoreBtn) return;

      e.preventDefault();
      e.stopPropagation();
      e.stopImmediatePropagation();

      if (loadMoreBtn.classList.contains('is-loading')) return;
      loadMoreBtn.classList.add('is-loading');
      loadMoreBtn.textContent = 'CARREGANDO...';

      let nextUrl = loadMoreBtn.getAttribute('href');
      if (!nextUrl) return;

      const currentSearchParams = window.location.search;
      if (currentSearchParams && !nextUrl.includes('sort_by') && currentSearchParams.includes('sort_by')) {
        const urlObj = new URL(nextUrl, window.location.origin);
        const currentParams = new URLSearchParams(currentSearchParams);
        currentParams.forEach((value, key) => {
          if (!urlObj.searchParams.has(key)) {
            urlObj.searchParams.set(key, value);
          }
        });
        nextUrl = urlObj.toString();
      }

      fetch(nextUrl)
        .then((response) => response.text())
        .then((html) => {
          const parser = new DOMParser();
          const doc = parser.parseFromString(html, 'text/html');

          const newItems = doc.querySelectorAll('.product-list__item');
          const currentGrid = document.querySelector('#product-grid') || document.querySelector('product-list');

          if (currentGrid && newItems.length > 0) {
            const fragment = document.createDocumentFragment();
            newItems.forEach((item) => fragment.appendChild(item));
            currentGrid.appendChild(fragment);
          }

          const newPagination = doc.querySelector('.load-more-pagination');
          const currentPagination = document.querySelector('.load-more-pagination');

          if (newPagination && currentPagination) {
            currentPagination.innerHTML = newPagination.innerHTML;
          } else if (currentPagination) {
            currentPagination.remove();
          }
        })
        .catch((error) => {
          console.error('Erro ao carregar mais produtos:', error);
          loadMoreBtn.classList.remove('is-loading');
          loadMoreBtn.textContent = 'VER MAIS';
        });
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
